"use client";

function ErrorPage({ message }: { message: string }) {
    return (
        <div className="fixed left-0 top-0 z-50 flex h-screen w-full flex-col items-center justify-center gap-8 rounded-none border-none bg-background-color p-4 text-center">
            <h1 className="text-2xl font-semibold text-primary md:text-3xl">
                Oops! Something Went Wrong
            </h1>
            <p className="text-base md:text-lg">{message}</p>
        </div>
    );
}

export default ErrorPage;
